import React from 'react';

const NeedHelp = () => (
  <va-need-help class="vads-u-margin-y--4">
    <div slot="content">
      <p>
        Call us at the VA benefits hotline at{' '}
        <va-telephone contact="8008271000" />. We’re here Monday through Friday,
        8:00 a.m to 9:00 p.m ET. If you have hearing loss, call{' '}
        <va-telephone contact="711" tty />.
      </p>
      <p>
        You can also call MyVA411 main information line at{' '}
        <va-telephone contact="8006982411" />. We’re here 24/7.
      </p>
      <p>Or you can use Ask VA to ask us a question online.</p>
      <p>
        <va-link
          href="/contact-us/ask-va"
          text="Contact us online through Ask VA"
        />
      </p>
    </div>
  </va-need-help>
);

export default NeedHelp;
